module.exports = __webpack_public_path__ + "media/images/icons/goldmann-arrow-c8a5bcb9001ba5012ca610bceedebee4.svg";